import React from 'react';
import styled from 'styled-components';
import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';
import Box from '../../spa/core-components/Box';

export interface Props {
    children: React.ReactNode;
    variations?: string[];
    className?: string;
}

const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
`;

export default function Card({ children, variations = [], className = '', ...props }: Props) {
    const classes = `${getComponentClasses('card', variations)} ${className}`.trim();

    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

export function DesignerCard({ meta, gallery, cta, variations = [] }: any) {
    return (
        <Card variations={variations.concat(['designer'])}>
            <Box
                paddingTop="space8"
                paddingRight="space8"
                paddingBottom="space8"
                paddingLeft="space8"
            >
                {meta}
            </Box>
            {gallery}
            <Box
                paddingTop="space8"
                paddingRight="space8"
                paddingBottom="space8"
                paddingLeft="space8"
            >
                {cta}
            </Box>
        </Card>
    );
}

export function DesignWithMetaCard({ image, meta, variations = [], ...props }: any) {
    return (
        <StyledCard {...props} variations={variations}>
            {image}
            <Box
                paddingTop="space8"
                paddingRight={['space8', 'space8', 'space10', 'space10']}
                paddingBottom="space8"
                paddingLeft={['space8', 'space8', 'space10', 'space10']}
                display="flex"
                flexDirection="column"
                flex="1"
            >
                {meta}
            </Box>
        </StyledCard>
    );
}
